














































































import Vue from 'vue';
import Tag from '@common/filter-tag/tag.vue';
import Slider from '@common/slider/slider.vue';

export default Vue.extend({
  name: 'ItineraryPreferencesPlaces',
  components: {Tag, Slider},
  props: {},
  data() {
    return {
      tags: [
        {name: 'My saved places', id: 1, iconType: 'HEART'},
        {name: 'Matches to preferences', id: 2, iconType: 'PREFERENCES'},
        {name: 'Special Places at Destination', id: 3, iconType: 'DESTINATION'},
        {name: 'Trip Advisor', id: 4, iconType: 'TRIP_ADVISOR', image: './img/trip-advisor.png'},
        {name: 'Time Out', id: 4, iconType: 'TIME_OUT', image: './img/time-out.png'},
      ],
      included_collections: [] as string[],
      num_of_reviews: ['1k', 'Above'],
      stay_rating: [4.5, 5],
      dining_rating: [4.5, 5],
      places_rating: [3, 5],
    };
  },
  methods: {
    toggleTag(filter: string) {
      if (this.included_collections.indexOf(filter) === -1) {
        this.included_collections = [...this.included_collections, filter];
      } else {
        this.included_collections = this.included_collections.filter((item) => item !== filter);
      }
    },
    handleReviewsChange(value: [0 | 1 | 2 | 3, 0 | 1 | 2 | 3]) {
      const mapper = {
        0: 'Any',
        1: '1k',
        2: '2k',
        3: 'Above',
      };
      this.num_of_reviews = [mapper[value[0]], mapper[value[1]]];
    },
    handleStayRatingChange(value: [number, number]) {
      this.stay_rating = value;
    },
    handleDiningRatingChange(value: [number, number]) {
      this.dining_rating = value;
    },
    handlePlacesRatingChange(value: [number, number]) {
      this.places_rating = value;
    },
    getTitle(value: number[]) {
      if (value[0] === 0) {
        return 'Any';
      }
      if (value[1] === 5) {
        return `${value[0]} and Above`;
      }
      return `From ${value[0]} to ${value[1]}`;
    },
    tagSelected(tagName: string) {
      return this.included_collections.includes(tagName);
    },
  },
  computed: {
    reviewsTitle(): string {
      if (this.num_of_reviews[0] === 'Any') {
        if (this.num_of_reviews[1] === 'Above') {
          return 'Any';
        }
        return `To ${this.num_of_reviews[1]}`;
      }

      if (this.num_of_reviews[1] === 'Above') {
        return `${this.num_of_reviews[0]} Reviews and Above`;
      }
      return `From ${this.num_of_reviews[0]} to ${this.num_of_reviews[1]}`;
    },
    stayTitle(): string {
      return this.getTitle(this.stay_rating);
    },
    diningTitle(): string {
      return this.getTitle(this.dining_rating);
    },
    placesTitle(): string {
      return this.getTitle(this.places_rating);
    },
    reviewValue(): number {
      const mapper = {
        Any: 0,
        '1k': 1,
        '2k': 2,
        Above: 3,
      };
      // @ts-ignore
      return [mapper[this.num_of_reviews[0]], mapper[this.num_of_reviews[1]]];
    },
  },
});
